export const environment = {
  production: false,
  apiUrl: 'https://pise.krealabs.dev',
};
